import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

//Set preserve globally so I18n elements animate inside <transition> elements properly.  Without this, text content using v-t disappears before transition is complete.
const i18n = new VueI18n({
    preserveDirectiveContent: true,
});

export default i18n;



// WEBPACK FOOTER //
// ./shared/locale/locale.js